<template>
	<div :class="{loading: loading}">
		<template v-if="loading">
			<LoadingBar v-if="!hideLoadingBar" />
			<div v-if="!hidePlaceholder" class="placeholder"></div>
		</template>

		<slot v-if="!loading || showContent"></slot>
	</div>
</template>

<script lang="ts" setup>
	/**
	 * Component to use when loading states are needed.
	 * Can be used in a couple of ways:
	 * - Show a loading bar and a placeholder card while loading
	 * - Wrap a component and show the component while loading.
	 *   This can be used to show a loading bar and make the cursor have a spinner state.
	 */
	import LoadingBar from '~/components/generic/LoadingBar.vue';

	defineProps({
		loading: {
			type: Boolean,
			default: true
		},
		hideLoadingBar: {
			type: Boolean,
			default: false
		},
		showContent: {
			type: Boolean,
			default: false
		},
		hidePlaceholder: {
			type: Boolean,
			default: false
		},
		height: {
			type: Number,
			default: 100
		}
	});
</script>

<style scoped>
	.loading {
		cursor: wait;
	}

	.placeholder {
		--placeholder-height: v-bind(height);
		background: #ffffff;
		width: 100%;
		height: calc(var(--placeholder-height) * 1px);
		max-height: 50vh;
	}
</style>
